<template lang="html">
  <div
    class="loading-container"
    :class="{ 'show': isLoading, 'loading-container__overlay': overlay }"
  >
    <div
      v-if="isLoading"
      :class="['loading-container__spinner-wrap', { 'loading-container__spinner-wrap--small': small }]"
    >
      <img
        class="loading-container__spinner"
        src="~@/assets/img/spinner.svg"
      >
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingContainer',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.loading-container {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(255,255,255, 0.5);

  &__overlay {
    position: fixed;
  }
}

.show {
  display: block;
  user-select: none;
}

.loading-container__spinner-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  color: #ACB4BE;
}

.loading-container__spinner-wrap--small {
  transform: translate(-50%, -50%) scale(0.5);
}

.loading-container__spinner {
  animation: spin 1.4s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
